import { configureStore } from '@reduxjs/toolkit';
import rootReducer from "../reducers";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { thunk } from "redux-thunk";

const persistConfig = {
  key: 'bhmm-app-storage',
  storage,
  blacklist: ['loading', 'toggleSidebar', 'networkRequests', 'sidebar', 'menuCard', 'stores', 'notification', 'advertising']
}

if (typeof window !== 'undefined' && window.localStorage) {
  const persistKey = `persist:${persistConfig.key}`;
  const resetTimestampKey = `${persistConfig.key}-lastReset`;
  const twoDaysMs = 2 * 24 * 60 * 60 * 1000;
  const lastReset = parseInt(window.localStorage.getItem(resetTimestampKey), 10);
  const now = Date.now();

  if (!lastReset || now - lastReset > twoDaysMs) {
    window.localStorage.removeItem(persistKey);
    window.localStorage.setItem(resetTimestampKey, String(now));
  }
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: () => ([thunk]),
  devTools: process.env.NODE_ENV !== 'production'
});

export const persistor = persistStore(store);